import StationTimelineEventsDataViewer from './StationTimelineEventsDataViewer'
import StationTimelineQueryHandler from './StationTimelineQueryHandler'
import StationTimelineSupportDataViewer from './StationTimelineSupportDataViewer'

export default {
  install( molten ) {    
    molten.addPlugin( 'DataViewer', StationTimelineEventsDataViewer )
    molten.addPlugin( 'DataViewer', StationTimelineSupportDataViewer )
    molten.addPlugin( 'EventQueryOptionsHandler', StationTimelineQueryHandler )
  },
}
